import App from 'app/app.js';
import 'app/service/GuidGenerator.js';

function SmileSafeService($http, $q, UserProfileStore, GuidGenerator) {
  this.submitEntry = function (requestData) {
    var deferred = $q.defer();

    $http
      .post('./smileSafe/submitEntry', {
        requestData: requestData,
        userProfile: UserProfileStore.userProfile,
        subjectId: GuidGenerator.generateGuid()
      })
      .then(function (response) {
        if (response.data.success) {
          deferred.resolve(response.data.data);
        } else {
          deferred.reject(response.data.error);
        }
      })
      .catch(function () {
        deferred.reject('SMILESAFE_SERVICE_FAILURE');
      });

    return deferred.promise;
  };
}

App.service('SmileSafeService', ['$http', '$q', 'UserProfileStore', 'GuidGenerator', SmileSafeService]);
